module.exports = __webpack_public_path__ + "static/media/fl2-cover-small.7a848bfa.png";